module.exports = __webpack_public_path__ + "images/newerp_webicon.1792033684119.png";